module.exports = __webpack_public_path__ + "static/media/marathon.c36a45f4.jpg";